import { ActionReducer, MetaReducer } from '@ngrx/store';
import * as utentiActionTypes from '../utenti/store/utenti.actions';
import * as glossariActions from '../glossari/store/glossari.actions';

/**
 * Funzione che intercetta le azioni prima del reducer e aggiunge eventuali azioni alla lista delle azioni annullabili
 * @param reducer {ActionReducer<any>}
 * @returns lo stato modificato (nella parte dell'undoredo) da passare al reducer
 */
export function utenti(reducer: ActionReducer<any>): ActionReducer<any> {
    return function (state, action) {
        let readableAction: any = { ...action }; //fuori if perchè su action non si riesce a leggere isUndoRedoOperation
        let undoValue: any;
        let currentValueForRedo: any;

        if (action.type === utentiActionTypes.UPDATE_USER_V2_SUCCESS && !readableAction.isUndoRedoOperation) {
            if (readableAction.payload.campoMod === 'password') {
                undoValue = {
                    "currentPassword": readableAction.payload.nuovoUtente.password,
                    "newPassword": state.utenti._elencoUtenti.find(el => el.id === readableAction.payload.nuovoUtente.id)[readableAction.payload.campoMod]
                }
                currentValueForRedo = {
                    "currentPassword": undoValue.newPassword,
                    "newPassword": undoValue.currentPassword
                }
            } else {
                undoValue = state.utenti._elencoUtenti.find(el => el.id === readableAction.payload.nuovoUtente.id)[readableAction.payload.campoMod];
                currentValueForRedo = readableAction.payload.nuovoUtente[readableAction.payload.campoMod];
            }
            const newPast = [
                ...state.undoredo.history.past,
                {
                    type: readableAction.type,
                    payload: {
                        idUser: readableAction.payload.nuovoUtente.id,
                        nomeCampo: readableAction.payload.campoMod,
                        newValue: undoValue
                    },
                    current: currentValueForRedo
                }
            ];
            return reducer({
                ...state,
                undoredo: {
                    ...state.undoredo,
                    history: {
                        ...history,
                        past: newPast.length > 0 ? [...newPast] : [],
                        future: [...state.undoredo.history.future]
                    }
                }
            }, action);

        } else if((action.type === utentiActionTypes.CREATE_USER_SUCCESS || action.type === utentiActionTypes.REMOVE_USER_SUCCESS) && !readableAction.isUndoRedoOperation) {
            const newPast = [
                ...state.undoredo.history.past,
                {
                    type: readableAction.type,
                    payload: {
                        idUser: action.type === utentiActionTypes.CREATE_USER_SUCCESS ? readableAction.payload.id : readableAction.payload
                    }
                }
            ];
            return reducer({
                ...state,
                undoredo: {
                    ...state.undoredo,
                    history: {
                        ...history,
                        past: newPast.length > 0 ? [...newPast] : [],
                        future: [...state.undoredo.history.future]
                    }
                }
            }, action);
        } else if (action.type === glossariActions.UPDATE_GLOSSARY_SUCCESS && !readableAction.isUndoRedoOperation) {
            undoValue = state.glossari.elencoVociGlossario.find(el => el.id === readableAction.payload.nuovoGlos.id)[readableAction.payload.campoMod];
            currentValueForRedo = readableAction.payload.nuovoGlos[readableAction.payload.campoMod];
            const newPast = [
                ...state.undoredo.history.past,
                {
                    type: readableAction.type,
                    payload: {
                        idGlos: readableAction.payload.nuovoGlos.id,
                        nomeCampo: readableAction.payload.campoMod,
                        newValue: undoValue
                    },
                    current: currentValueForRedo
                }
            ];
            return reducer({
                ...state,
                undoredo: {
                    ...state.undoredo,
                    history: {
                        ...history,
                        past: newPast.length > 0 ? [...newPast] : [],
                        future: [...state.undoredo.history.future]
                    }
                }
            }, action);
        } else if((action.type === glossariActions.ADD_NEW_GLOSSARY_SUCCESS || action.type === glossariActions.REMOVE_GLOSSARY_SUCCESS) && !readableAction.isUndoRedoOperation) {
            const newPast = [
                ...state.undoredo.history.past,
                {
                    type: readableAction.type,
                    payload: {
                        idGlos: action.type === glossariActions.ADD_NEW_GLOSSARY_SUCCESS ? readableAction.payload.newGlos.id : readableAction.payload
                    }
                }
            ];
            return reducer({
                ...state,
                undoredo: {
                    ...state.undoredo,
                    history: {
                        ...history,
                        past: newPast.length > 0 ? [...newPast] : [],
                        future: [...state.undoredo.history.future]
                    }
                }
            }, action);
        }
        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<any>[] = [utenti];